import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  onReset(): void;
}

export default function EmptyState({ onReset }: IProps) {
  return (
    <div className={cx('error')}>
      <h5 className={cx('title')}>검색된 항공권이 없습니다</h5>
      <span className={cx('txt')}>
        선택하신 조건으로 검색된 항공권이 없습니다
        <br />
        적용된 필터 조건을 확인해보세요
      </span>
      <button
        type="button"
        className={cx('search')}
        onClick={onReset}
        data-event-nlog="click"
        data-event-area-code="rcm.filterrest"
      >
        <svg
          className={cx('icon')}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.3029 7.99399C14.3029 11.4776 11.4789 14.3029 7.99436 14.3029C4.51055 14.3029 1.68579 11.4776 1.68579 7.99399C1.68579 4.51038 4.51055 1.68579 7.99436 1.68579C9.73664 1.68579 11.3138 2.39194 12.4553 3.53335"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4651 3.53516C12.8841 3.9545 13.2447 4.43216 13.5333 4.95513"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5715 1.08569V5.02855H9.62866"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        상세조건 초기화
      </button>
    </div>
  );
}
